import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TermsOfServicePDF from '../assets/SP_Labs_ToS.pdf';
import PrivacyPDF from '../assets/SP_Labs_PP.pdf';
import SpLabsLogo from "../assets/SP-Labs-logo.png";

import LinkedInLogo from "../assets/linked_in_icon.png";
import TwitterLogo from "../assets/twitter_icon.png";
import YouTubeLogo from "../assets/YouTube_icon.png";

import ContactUsModal from "./ContactUsModal";

import "./Footer.css";

const Footer = () => {

    const navigate = useNavigate();

    const [showContactUsModal, setShowContactUsModal] = useState(false);

    return (
        <section className="footer-section">
            {showContactUsModal && <ContactUsModal closeModal={() => setShowContactUsModal(false)} />}
            <div className="footer-container">
                <div className="footer-col">
                    <img src={SpLabsLogo} id="footer-sp-labs-logo" />
                    <a className={`footer-link-text`} href={TermsOfServicePDF} target="_blank">Terms of Service</a>
                    <a className={`footer-link-text`} href={PrivacyPDF} target="_blank">Privacy Policy</a>
                    <a className={`footer-link-text`} onClick={() => navigate('/ai-basics')}>Learn</a>
                    <a className={`footer-link-text`} onClick={() => setShowContactUsModal(true)}>
                        Contact us
                    </a>
                </div>
                <div className="footer-socials-col">
                    <img src={LinkedInLogo} onClick={() => window.open("https://www.linkedin.com/company/90594322/admin/feed/posts/", "_blank")} className="footer-social-logo" id="linked-in-logo" />
                    <img src={TwitterLogo} onClick={() => window.open("https://twitter.com/superpowered_ai", "_blank")} className="footer-social-logo" id="twitter-logo" />
                    <img src={YouTubeLogo} onClick={() => window.open("https://www.youtube.com/@Superpowered_AI", "_blank")} className="footer-social-logo" id="youtube-logo" />
                </div>
            </div>
        </section>
    )

}

export default Footer;